import { useRef, useCallback, useEffect } from "react";

export default function useAbortableFetch() {
  const controllerRef = useRef(null);

  const abortable = useCallback(async (fn) => {
    // 1. cancel any ongoing request
    if (controllerRef.current) {
      controllerRef.current.abort();
    }

    // 2. create a new controller
    const controller = new AbortController();
    controllerRef.current = controller;

    try {
      // 3. run the caller's function with the new signal
      return await fn(controller.signal);
    } finally {
      // 4. clear the controller reference after completion
      controllerRef.current = null;
    }
  }, []);

  useEffect(() => () => controllerRef.current?.abort(), []);

  return abortable;
}
